import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import VideoCardV2 from '../VideoCardV2';
import { generatePlayerPageViewUrl } from '../../utils/generatePlayerPageViewUrl';

import { SHOPIFY_PRODUCT_LINK } from '../../constants/SocialMediaLinks';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../../data/atoms/utilsAtoms';
import videoApi from '../../api/videoApi';
import api from '../../data/api';
import Toast from '../../utils/toastManager';
import AddToPlayListModal from '../playlist/personal-playlist/AddToPlayListModal';
import { useVideoDetailsFromParams } from '../../Pages/VideoPlayer/hooks/useVideoDetailsFromParams';
import NoVideosFoundSection from '@/v2/components/NoVideosFoundSection';

const ClassesVideoList = ({ products = [], videos = [], typeOfContentView = 'classes', isLoading = false }) => {
	const location = useLocation();
	const [videoData, setVideoData] = useState(null);
	const [modal, setModal] = useState(false);
	const navigate = useNavigate();
	const { playlistId } = useVideoDetailsFromParams();
	const userData = useAtomValue(userInfoAtom);
	const [savedVideos, setSavedVideos] = useState([]);
	const [refreshSavedVideos, setRefreshSavedVideos] = useState(null);
	const [hoverEffect, setHoverEffect] = useState(true);

	useEffect(() => {
		if (userData.token) {
			videoApi.getAllSavedVideoIds(userData.user?.userId).then(res => setSavedVideos(res.data.savedVideos));
		}
	}, [userData, refreshSavedVideos]);

	useEffect(() => {
		if (location?.pathname?.startsWith('/PlayerPage')) {
			setHoverEffect(false);
		}
	}, [location.pathname]);

	const handleSaveUnsave = async video => {
		const isLiked =
			video.videoDetails?.savedvideo ||
			video.savedvideo ||
			(savedVideos?.length > 0 && savedVideos?.includes(video?.videoDetails?._id || video?._id)) ||
			savedVideos?.includes(video?._id);

		if (isLiked) {
			try {
				const response = await api.unsaveWishlist(video._id, userData.token);
				if (response.status === 200) {
					Toast.success('Unsaved');
					setRefreshSavedVideos(response.data);
				}
			} catch (error) {
				console.error('Error fetching data: ', error);
			}
		} else {
			try {
				const response = await api.saveWishlist(video._id, userData.token);
				if (response.status === 200) {
					Toast.success('Saved');
					setRefreshSavedVideos(response.data);
				}
			} catch (error) {
				console.error('Error fetching data: ', error);
			}
		}
	};

	const redirectToVideo = videoId => {
		if (!modal) {
			const url = generatePlayerPageViewUrl(videoId, typeOfContentView, playlistId);
			navigate(url);
		}
	};

	const redirectToProduct = handle => {
		const url = `${SHOPIFY_PRODUCT_LINK}/${handle}`;
		window.open(url, '_blank');
	};

	const hasNoData = videos.length === 0 && (!products || products.length === 0);

	return (
		<>
			<div>
				{!isLoading && hasNoData && <NoVideosFoundSection />}
				<Row xs={1} md={2} className="g-0 mb-5 mt-3 mt-md-0">
					{videos.length > 0 &&
						videos.map(video => {
							const hasComingSoonTag = video.tagsDetails?.some(tag => tag.name === "coming soon");

							const videoCard = (
								<VideoCardV2
									video={video}
									savedVideos={savedVideos}
									handleSaveUnsave={handleSaveUnsave}
									modal={modal}
									setModal={setModal}
									setVideoData={setVideoData}
									customStyles={{ minWidth: '225px' }}
									titleStyles={{ fontSize: hoverEffect ? 'clamp(1.3rem, 2vw, 2rem)' : '1rem' }}
									hoverEffect={hoverEffect}
									showAddToPlaylistIcon
									showSaveIcon
								/>
							);

							return (
								<Col key={video._id} className="p-2 d-flex justify-content-center">
									{hasComingSoonTag ? (
										<div onClick={(e) => e.preventDefault()}>
											{videoCard}
										</div>
									) : (
										<div onClick={() => redirectToVideo(video._id)} style={{ cursor: "pointer" }}>
											{videoCard}
										</div>
									)}
								</Col>
							);
						})}
				</Row>

				{products && products?.length > 0 && (
					<div className="">
						<Row xs={1} md={2} className="g-0">
							{products.map(product => (
								<Col key={product.handle} className="p-2 d-flex justify-content-center">
									<div onClick={() => redirectToProduct(product.handle)}>
										<VideoCardV2 product={product} customStyles={{ minWidth: '200px' }} />
									</div>
								</Col>
							))}
						</Row>
					</div>
				)}
			</div>
			<AddToPlayListModal modal={modal} setModal={setModal} activeObject={videoData} />
		</>
	);
};

export default ClassesVideoList;
